import { useState } from 'react';
import { Container, Row, Col } from 'react-bootstrap'
import { Link } from 'react-router-dom'
import { FaWhatsapp } from 'react-icons/fa';
import { FaUser } from 'react-icons/fa';
import DeliveryPartnerTermsModal from './DeliveryPartnerTermsModal';
import DeliveryPartnerPrivacyPolicyModal from './DeliveryPartnerPrivacyPolicyModal';

const DeliveryPartnerFooter = () => {
  const currentYear = new Date().getFullYear();

  const whatsappContact = "919390595210";
  const whatsappMessage = "Hi, I have the following enquiry.";
  const whatsappUrl = `https://wa.me/${whatsappContact}?text=${encodeURIComponent(whatsappMessage)}`;

  const [showTerms, setShowTerms] = useState(false);
  const [showPrivacyPolicy, setShowPrivacyPolicy] = useState(false);

  return (
    <footer>
        <Container>
            <Row>
                <Col className='text-center py-3'>
                    <p>NCG Global Enterprises &copy; {currentYear}</p>
                    <p>
                      <Link to="/contact" className="terms-text-link">
                        Contact Us
                      </Link>
                      &nbsp;| Contact on WhatsApp&nbsp;
                      <a href={whatsappUrl} target="_blank" rel="noopener noreferrer">
                        <FaWhatsapp style={{ color: 'green', fontSize: '2rem', fontStyle: "bold" }}/>
                      </a>
                      &nbsp;|&nbsp;                    
                      <span
                        className="terms-text-link"
                        onClick={() => setShowTerms(true)}
                        role="button"
                        tabIndex={0}
                      >
                        Terms & Conditions
                      </span>
                      <DeliveryPartnerTermsModal show={showTerms} onHide={() => setShowTerms(false)} />
                      &nbsp;|&nbsp;                    
                      <span
                        className="terms-text-link"
                        onClick={() => setShowPrivacyPolicy(true)}
                        role="button"
                        tabIndex={0}
                      >
                        Privacy Policy
                      </span>
                      <DeliveryPartnerPrivacyPolicyModal show={showPrivacyPolicy} onHide={() => setShowPrivacyPolicy(false)} />
                      &nbsp;| Customer Website&nbsp;
                      <a href='/' target="_blank" rel="noopener noreferrer">
                        <FaUser style={{ color: "#2c66c2", fontSize: '1.5rem', fontStyle: "bold" }}/>
                      </a>
                    </p>
                </Col>
            </Row>
        </Container>
    </footer>
  )
}

export default DeliveryPartnerFooter;